import type { TttPresaleItem, TttPresaleI18n } from "@/components/ttt/types"

interface PresaleCardProps {
  item: TttPresaleItem
  dotsSrc: string
  i18n: TttPresaleI18n
}

// Faithful React port of app/components/ttt/presale_item/component.html.slim:
// a landscape (16/9) tile linking out to the crowdfunding campaign, with a
// floating name/status header and a description that slides up on hover.
export default function PresaleCard({ item, dotsSrc, i18n }: PresaleCardProps) {
  return (
    <a
      href={item.external_link ?? "#"}
      target="_blank"
      rel="noreferrer"
      className="w-full relative group rounded-md font-ttt-title"
    >
      <div
        className="relative overflow-hidden group w-full rounded-md transition-all duration-300 group-hover:rotate-3"
        style={{ aspectRatio: "16/9" }}
      >
        {item.image_url && (
          <img
            src={item.image_url}
            alt={item.name}
            className="w-full h-full object-contain object-bottom"
          />
        )}
        <img
          src={dotsSrc}
          alt=""
          className="absolute left-0 bottom-0 w-full object-contain pointer-events-none group-hover:-bottom-36 transition-all duration-300"
        />
      </div>

      <div className="absolute transition-all duration-300 left-1/2 -translate-x-1/2 -top-6 flex flex-col items-center">
        <div className="text-center text-primary bg-light py-2 px-4 rounded-lg border border-primary mb-3">
          <div className="text-sm uppercase font-bold">{item.name}</div>
        </div>
        <div className="text-center text-primary text-xs bg-light py-2 px-4 rounded-lg border border-primary inline-block">
          {i18n.funding_in_progress}
        </div>
      </div>

      <div className="absolute left-1/2 w-2/3 -translate-x-1/2 text-center text-xs text-primary bg-light py-2 px-4 rounded-lg border border-primary -bottom-6 transition-all duration-300 group-hover:bottom-10">
        {i18n.description}
      </div>
    </a>
  )
}
